import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';

import { POST_RECESS_REQUEST, POST_RECESS_SUCCESS, POST_RECESS_FAILURE, COMMON_FAILURE } from '../../actions';
import { recessService } from '../../services';
import { historyType } from '../../../utils/commonType';

export type postRecessAction = {
  type: typeof POST_RECESS_REQUEST;
  memberNo: string;
  shopId: string;
  startMonth: string;
  endMonth: string;
  history: historyType;
};

function* postRecess(action: postRecessAction): Generator<unknown> {
  try {
    const res: any = yield call(recessService(action).postRecess);
    yield put({
      type: POST_RECESS_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: POST_RECESS_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchPostRecess() {
  yield takeLatest(POST_RECESS_REQUEST, postRecess);
}

export default function* recessSaga(): Generator<unknown> {
  yield all([fork(watchPostRecess)]);
}
